/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import { getProductDetailProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "ProductDetailPageService";
const log: any = LoggerModule.getInstance();

export class GetProductDetailPageService {
  private static instance: GetProductDetailPageService;
  private vapp: VApplication;
  private productDetailRestAPI: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.productDetailRestAPI = props?.productDetailRestAPI;
  }

  public static getInstance(props: any = {}): GetProductDetailPageService {
    if (!GetProductDetailPageService.instance) {
      GetProductDetailPageService.instance = new GetProductDetailPageService(props);
    }
    return GetProductDetailPageService.instance;
  }

  //private instances

  //------------------------------------

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getProductDetail(args: getProductDetailProps) {
    console.log(` in index of service :`, args);
    let _args = {
      apiURL: this.productDetailRestAPI,
    };
    const agent = getAgent();
    return agent.getProductDetail(_args);
  }
}
